import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.67 4.061c-.222.081-.42.248-.542.455-.092.156-.108.229-.107.484 0 .212.022.341.074.44.04.077 1.291 1.36 2.779 2.85L16.579 11h-5.843c-4.835 0-5.875.009-6.026.055a1.02 1.02 0 0 0-.582.461c-.091.156-.108.23-.108.484 0 .256.016.328.111.489.125.213.318.375.539.454.123.044 1.222.054 6.03.055l5.879.002-2.705 2.71c-1.488 1.491-2.739 2.773-2.779 2.85-.052.099-.074.228-.074.44-.001.258.015.327.112.492.13.222.369.409.603.473.202.054.53.024.709-.066.185-.092 7.292-7.192 7.428-7.419.091-.152.107-.226.107-.48s-.016-.328-.107-.48c-.062-.103-1.644-1.713-3.72-3.785-3.302-3.294-3.63-3.61-3.81-3.67a1 1 0 0 0-.673-.004"
    }, null, -1)
  ])))
}
export default { render: render }